import { useAtom } from "jotai";
import { taggingInformationDataAtom } from "./atoms";

export function useTaggingInformationData() {
  const [{ data, isLoading, error }] = useAtom(taggingInformationDataAtom);
  return {
    content: data,
    isLoading,
    error,
  };
}
